import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  children: any
}
export const BlankWindow = (props: Props) => {
  const [container, setContainer] = useState<any>(null)
  const newWindow = useRef<any>(null)

  useEffect(() => {
    setContainer(document.createElement('div'))
  }, [])

  useEffect(() => {
    if (container) {
      newWindow.current = window.open(
        '',
        '',
        // 'width=1920,height=1000,left=0,top=0'
      )
      newWindow.current.document.body.appendChild(container)

      const curWindow = newWindow.current
      setTimeout(() => curWindow.print(), 300)

      return () => curWindow.close()
    }
  }, [container])

  return container && createPortal(props.children, container)
}
